<template>
    <div>
        <v-dialog persistent v-model="dialog" width="420px">
            <v-card width="780px">
                <v-card-title style="background: #455a64; color:white">
                    <span class="overline font-weight-black">提案電気図面依頼 (PDR)</span>
                </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-radio-group
                                v-model="radioPdr"
                                column
                                hide-details
                                class="ml-3">
                                <v-radio
                                    label="標準プラン"
                                    value="1">
                                </v-radio>
                                <v-radio
                                    label="提案プラン"
                                    value="2">
                                </v-radio>
                                <v-radio
                                    label="ＣＡＤ図面（配線位置を記入したもの）添付あり"
                                    value="3">
                                </v-radio>
                                <!-- <v-radio
                                    label="なし"
                                    value="4">
                                </v-radio> -->
                            </v-radio-group>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn dark color="red" @click="cancelPdr">キャンセル</v-btn>
                            <v-btn dark color="green" @click="submitPdr" >保存</v-btn>
                    </v-card-actions>
                    <!-- 大きな変更 (L) -->
            </v-card>   
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    props: {
        dialog : Boolean
    },
    data: () => ({
        radioPdr : null,
    }),

    computed: {
        ...mapState([
            'cadRequestRevisionContent',
            'editMode',
            'editCadRequestRevisionContent',
            'previousAttachmentFiles', 
        ]),
    },

    methods: {
        toggleDialogPdr(value){
            this.$emit('toggleDialogPdr', value)
        },

        submitPdr(){
            this.$emit('submitPdr', this.radioPdr)
            this.toggleDialogPdr(false)
            return;
        },

        cancelPdr(){
            this.$emit('cancelPdr', null)
            this.toggleDialogPdr(false)
        }
    },

    watch: {
        "$store.state.editMode"(val){
            if(val) {
                this.radioPdr = this.$store.state.editCadRequestRevisionContent
            }
        }
    }






}
</script>